import React, { useEffect, useRef, useState } from 'react';
import styles from './CVBuilder.module.scss';
import CVPrinter from './CVPrinter/CVPrinter';
import BasicThemeCVBuilder from 'Components/BasicTheme/BasicTheme';
import { onPDFDownloadHandler } from 'shared/Utils/PDFDownloader/PDFDownloader';
import { onInitializeCVData } from 'Containers/CVBuilder/Data/defaultCVData';
import { onInitializeExperienceata } from 'Containers/CVBuilder/Data/defaultCVData';
// import { dataURItoBlob } from 'shared/Utils/DataURIToBlogConverter/DataURIToBlogConverter';
import _ from 'lodash';

const experience = {
    position: '',
    company: '',
    startDate: '',
    endDate: '',
    description: ''
};

const education = {
    organization: '',
    program: '',
    startDate: '',
    endDate: ''
};

function CVBuilder() {
    const a4ContainerRef = useRef(null);

    const downloadResumePDF = () => {
        setISDownloadingCVPDF(true);
        const downloaderTimeOut = setTimeout(() => {
            onPDFDownloadHandler(
                a4ContainerRef,
                `${cvBuilderForm.firstName} ${cvBuilderForm.lastName} - ${cvBuilderForm.designation} CV`
            );
            setISDownloadingCVPDF(false);
            clearTimeout(downloaderTimeOut);
        }, 2000);
    };

    const [cvBuilderForm, setCVBuilderForm] = useState({
        firstName: '',
        lastName: '',
        designation: '',
        email: '',
        website: '',
        phone: '',
        city: '',
        country: '',
        profileImageSrc: '',
        experience: [_.cloneDeep(experience)],
        education: [_.cloneDeep(education)]
    });

    useEffect(() => {
        // TODO: Remove next 4 lines if you don't want to initialize dummy data
        let updatedData = _.cloneDeep(cvBuilderForm);
        updatedData = onInitializeCVData(updatedData);
        updatedData = onInitializeExperienceata(updatedData);
        setCVBuilderForm(updatedData);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [isDownloadingCVPDF, setISDownloadingCVPDF] = useState(false);

    const onKeyDownHandler = (e) => {
        e.target.style.height = 'inherit';
        const computed = window.getComputedStyle(e.target);
        const height =
            parseInt(computed.getPropertyValue('border-top-width'), 10) +
            parseInt(computed.getPropertyValue('padding-top'), 10) +
            e.target.scrollHeight +
            parseInt(computed.getPropertyValue('padding-bottom'), 10) +
            parseInt(computed.getPropertyValue('border-bottom-width'), 10);
        e.target.style.height = `${height}px`;
    };

    const onInputChangedHandler = (event, controlName) => {
        let updatedData = _.cloneDeep(cvBuilderForm);

        updatedData = {
            ...updatedData,
            [controlName]: event.target.value
        };

        setCVBuilderForm(updatedData);
    };

    const onAddExperience = () => {
        let updatedData = _.cloneDeep(cvBuilderForm);
        const previousExperience = _.cloneDeep(updatedData.experience);

        updatedData = {
            ...updatedData,
            experience: [...previousExperience, _.cloneDeep(experience)]
        };

        setCVBuilderForm(updatedData);
    };

    const onDeleteExperienceHandler = (experienceIndex) => {
        let updatedData = _.cloneDeep(cvBuilderForm);
        let previousExperience = [..._.cloneDeep(updatedData.experience)];
        previousExperience.splice(experienceIndex, 1);

        updatedData = {
            ...updatedData,
            experience: previousExperience
        };

        setCVBuilderForm(updatedData);
    };

    const onExperienceChangeHandler = (event, experienceIndex, controlName) => {
        let updatedData = _.cloneDeep(cvBuilderForm);
        const updatedExperienceList = [..._.cloneDeep(updatedData.experience)];
        updatedExperienceList[experienceIndex] = {
            ...updatedExperienceList[experienceIndex],
            [controlName]: event.target.value
        };

        updatedData = {
            ...updatedData,
            experience: updatedExperienceList
        };

        setCVBuilderForm(updatedData);
    };

    const onAddEducation = () => {
        let updatedData = _.cloneDeep(cvBuilderForm);
        const previousEducation = _.cloneDeep(updatedData.education);

        updatedData = {
            ...updatedData,
            education: [...previousEducation, _.cloneDeep(education)]
        };

        setCVBuilderForm(updatedData);
    };

    const onDeleteEducationHandler = (educationIndex) => {
        let updatedData = _.cloneDeep(cvBuilderForm);
        let previousEducation = [..._.cloneDeep(updatedData.education)];
        previousEducation.splice(educationIndex, 1);

        updatedData = {
            ...updatedData,
            education: previousEducation
        };

        setCVBuilderForm(updatedData);
    };

    const onEducationChangeHandler = (event, educationIndex, controlName) => {
        let updatedData = _.cloneDeep(cvBuilderForm);
        const updatedEducationList = [..._.cloneDeep(updatedData.education)];
        updatedEducationList[educationIndex] = {
            ...updatedEducationList[educationIndex],
            [controlName]: event.target.value
        };

        updatedData = {
            ...updatedData,
            education: updatedEducationList
        };

        setCVBuilderForm(updatedData);
    };

    const onUploadUserProfileImageHandler = (event, profileImageRef) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = function () {
            profileImageRef.current.src = reader.result;

            const profileImageSrc = reader.result;
            let updatedData = _.cloneDeep(cvBuilderForm);

            updatedData = {
                ...updatedData,
                profileImageSrc
            };
            setCVBuilderForm(updatedData);

            // TODO: USE THIS IF YOU WANT TO UPLOAD THE IMAGE BLOB
            // const blob = dataURItoBlob(reader.result);
            // console.log(
            //     blob,
            //     new File([blob], 'image.png', {
            //         type: 'image/png'
            //     })
            // );
        };
        reader.readAsDataURL(file);
    };

    let mainContentUI = (
        <BasicThemeCVBuilder
            cvBuilderForm={cvBuilderForm}
            handleKeyDown={onKeyDownHandler}
            onInputChangedHandler={onInputChangedHandler}
            onAddExperience={onAddExperience}
            onDeleteExperienceHandler={onDeleteExperienceHandler}
            onExperienceChangeHandler={onExperienceChangeHandler}
            onAddEducation={onAddEducation}
            onDeleteEducationHandler={onDeleteEducationHandler}
            onEducationChangeHandler={onEducationChangeHandler}
            onUploadUserProfileImage={onUploadUserProfileImageHandler}
        />
    );

    if (isDownloadingCVPDF) {
        mainContentUI = (
            <CVPrinter cvData={cvBuilderForm} a4ContainerRef={a4ContainerRef} />
        );
    }

    return (
        <>
            <header className={`row ${styles.Header}`}>
                <div className="col-4">
                    <img src="images/temp.svg" alt="" />
                </div>
                <div className="col-4 text-center">
                    <strong>CVBuilder.com</strong>
                </div>
                <div className="col-4 text-end">
                    <time>Monday 8 August 13:57</time>
                </div>
            </header>

            <section
                className={`row ${styles.CVBuilderContainer} justify-content-center`}>
                {mainContentUI}
                <div className={`${styles.CVActionsContainer}`}>
                    <button
                        onClick={downloadResumePDF}
                        className={`btn btn-primary btn-lg ${styles.ExportCVPDFButton}`}>
                        Export PDF
                    </button>
                </div>

                <img
                    className={`${styles.BackgroundCoverImage}`}
                    src="/images/squares.svg"
                    alt=""
                />
            </section>
        </>
    );
}

export default CVBuilder;
